import { useNavigation } from '@react-navigation/native'
import React, { useState } from 'react'

import { NameInput } from 'pages/CoachOnboarding/subcomponents/NameInput'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'
import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'
import { useStripe } from 'hooks/useStripe'

import { links } from 'utils/constants'

import { useCoachOnboardingModal } from 'contexts/CoachOnboardingModalContext'

type UpspaceNamePageProps = {
  handleSelection: (isGroup: boolean) => void
}

export const UpspaceNamePage = ({ handleSelection }: UpspaceNamePageProps) => {
  const navigation = useNavigation<any>()
  const navigateBackOrHome = useNavigateBackOrHome()
  const coachOnboardingModalRef = useCoachOnboardingModal()
  const { data: currentUser, update: updateUser } = useCurrentUser()

  const [upspaceTitle, setUpspaceTitle] = useState<string | null>()

  const { data: group, updateGroup } = useGroup({ userId: currentUser?.id })
  const { createProgram } = useStripe()

  const setupProgram = async () => {
    if (!group?.id) return null

    const createdProgram = await createProgram.mutateAsync({
      programId: group.id,
      title: upspaceTitle?.trim() ?? `${currentUser?.firstName} ${currentUser?.lastName}'s Group`,
      description: `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.id})'s Group`,
      price: 0,
    })

    return createdProgram
  }

  const handleNextPress = async () => {
    if (!group?.title) {
      await setupProgram()
    } else {
      updateGroup.mutate({
        ...group,
        title: upspaceTitle?.trim() ?? `${currentUser?.firstName} ${currentUser?.lastName}'s Group`,
      })
    }

    if (!currentUser?.isTrainer) {
      updateUser.mutate({ data: { type: 'trainer' } })
    }

    navigation.navigate(links.UPSPACE_DESCRIPTION_PAGE)
  }

  const handleBack = () => {
    handleSelection(false)
    navigateBackOrHome()
  }
  return (
    <Box testID='UpspaceNamePage' flexDirection='column' backgroundColor='v2primary' flex={1}>
      <BottomSheetNav
        withBack
        onBackPress={handleBack}
        withClose
        bottomSheetRef={coachOnboardingModalRef}
      />
      <NameInput
        input={upspaceTitle}
        setInput={setUpspaceTitle}
        onNext={handleNextPress}
        promptTitle='What would you like to name your Group?'
        inputPlaceholder={`${currentUser?.firstName} ${currentUser?.lastName}'s Group`}
      />
    </Box>
  )
}
